module.exports = __webpack_public_path__ + "img/shot_img20032001.edd9c3e7.gif";